import {
    ClearButtonHolder,
    LinkoutUrlTextField,
    StyledIconButton,
} from "./PostForm.styles";
import React, { MutableRefObject } from "react";
import { CircleXMarkIcon } from "@icons/CircleXMarkIcon";
import { LinkSolidIcon } from "@icons/LinkSolidIcon";
import { CommentFormModeEnum } from "../../Modals/CommentFormModal/CommentFormModalOpenState";

export function LinkoutField({
    errorText,
    linkoutRef,
    linkoutUrl,
    setLinkoutUrl,
    onClear,
    mode,
    setMode,
}: {
    errorText: string;
    linkoutRef: MutableRefObject<HTMLInputElement>;
    linkoutUrl: string;
    mode: CommentFormModeEnum | undefined;
    onClear: () => void;
    setLinkoutUrl: (value: string) => void;
    setMode: (value?: CommentFormModeEnum) => void;
}) {
    return (
        <LinkoutUrlTextField
            className={errorText.length ? "_error" : ""}
            fullWidth={true}
            inputRef={linkoutRef}
            variant="outlined"
            autoFocus={CommentFormModeEnum.LINKOUT === mode}
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    linkoutRef.current?.blur();
                }
            }}
            onFocus={() => {
                setMode(CommentFormModeEnum.LINKOUT);
            }}
            value={linkoutUrl}
            onChange={(event) => {
                setLinkoutUrl(event.target.value);
            }}
            placeholder={"https://"}
            InputLabelProps={{
                shrink: linkoutUrl?.length > 0,
            }}
            InputProps={{
                startAdornment: (
                    <LinkSolidIcon
                        width="16px"
                        height="16px"
                        color={"var(--community-color-primary-text)"}
                    />
                ),
                endAdornment: (
                    <ClearButtonHolder position="end">
                        <StyledIconButton
                            aria-label="clear input"
                            onPointerUp={onClear}
                            onTouchEnd={(e) => {
                                e.stopPropagation();
                                e.preventDefault();
                            }}
                            edge="end"
                        >
                            <CircleXMarkIcon
                                width={"24px"}
                                height={"24px"}
                                color={
                                    "var(--community-color-transparent-black-20)"
                                }
                            />
                        </StyledIconButton>
                    </ClearButtonHolder>
                ),
            }}
        />
    );
}
